import { tracker } from "analytics/tracker";
import { TRACK_ACTION, TRACK_PAGE_VIEW } from "redux/ActionTypes";

const initialState = {
  lastEvent: null,
  eventHistory: [],
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRACK_PAGE_VIEW: {
      const { eventType, metadata } = action.payload;

      tracker.trackEvent(eventType, {
        action_type: "view",
        ...metadata,
      });

      return {
        ...state,
        lastEvent: {
          type: "view",
          eventType,
          metadata,
          timestamp: Date.now(),
        },
        eventHistory: [
          ...state.eventHistory.slice(-49),
          {
            type: "view",
            eventType,
            metadata,
            timestamp: Date.now(),
          },
        ],
      };
    }

    case TRACK_ACTION: {
      const { eventType, metadata } = action.payload;

      tracker.trackEvent(eventType, {
        action_type: "action",
        ...metadata,
      });

      return {
        ...state,
        lastEvent: {
          type: "action",
          eventType,
          metadata,
          timestamp: Date.now(),
        },
        eventHistory: [
          ...state.eventHistory.slice(-49),
          {
            type: "action",
            eventType,
            metadata,
            timestamp: Date.now(),
          },
        ],
      };
    }

    default:
      return state;
  }
};

export default analyticsReducer;
